export default class BookDemo {
  constructor() {
    this.$el = document.querySelector('.js-book-demo');
    if (!this.$el) return;

    this.$cta = this.$el.querySelector('a.c-cta');

    if (this.$cta && this.$cta.href.indexOf('#') > -1) {
      this.$cta.addEventListener('click', (e) => {
        e.preventDefault();
        const id = this.$cta.href.split('#')[1];
        const $target = document.getElementById(id);
        $target.scrollIntoView({ behavior: 'smooth' });
      });
    }
  }
}
